module.exports = __webpack_public_path__ + "img/mytoken.8e70c818.png";